import axios from 'axios';

const getAccessToken = async (): Promise<string | undefined> => {
  try {
    const url = '/streamchat/accessToken';

    const { data } = await axios.get<string>(url);

    return data;
  } catch (error) {
    console.error('Error fetching Stream Chat Access token:', error);
  }
};

export default getAccessToken;
